@if (stripePaymentError) {
  <div class="alert alert-danger">{{ stripePaymentError }}</div>
}
<div class="row">
  <div class="col">
    @if (checkoutSignupLogin) {
      <app-signup-login [existingUser]="!!user" [purchaserInfo]="info"></app-signup-login>
    }
    <h3>Billing Info</h3>
    <div class="stripe-address">
      <div class="form-group">
        <label for="email" class="form-label">{{ formComponents.email.label }}</label>
        <input
          type="email"
          id="email"
          class="form-control"
          [value]="formComponents.email.value"
          (change)="setValue($event, 'email')">
      </div>
      <div id="stripe-address"></div>
    </div>
    <div [hidden]="stripePrimaryPaymentMethod && !showCardForm">
      @if ((stripePaymentMethods.length || stripePrimaryPaymentMethod)) {
        <a (click)="showCardForm = false"
          class="show-saved-cards">
          Use a saved card
        </a>
      }
      <div id="stripe-card"></div>
      @if (user) {
        <div>
          <input type="checkbox" id="save-card" [(ngModel)]="optedInToSaveCard">
          <label for="save-card">
            Save this credit card on my account to make checkout easier next time
          </label>
        </div>
      }

    </div>

    @if ((!showCardForm && user) && (stripePaymentMethods.length || stripePrimaryPaymentMethod)) {
      <app-stripe-stored-cards
        [user]="user"
        [customer]="stripeCustomer"
        [paymentMethods]="stripePaymentMethods"
        [primaryPaymentMethod]="stripePrimaryPaymentMethod"
        (selectedCard)="selectedStripeCard($event)"
      (useNewCard)="useNewCard()"></app-stripe-stored-cards>
    }
  </div>
</div>

<br><br>
<div class="text-center">
  <button type="button" [disabled]="inProgress" (click)="onSubmit($event)" class="button regular solid-green submit-purchase">
    {{inProgress ? 'Submitting Payment' : 'Complete Purchase'}}
  </button>
  <div class="credit-header">
    <br>
      <br>
        <p>— OR —</p>
        <br>
        </div>
        <div class="paypal-container">
          <div id="paypal-button" [hidden]="paypalDisabled"></div>
          @if (paypalDisabled) {
            <div class="flex flex-column paypal-disabled">
              <div class="paypal-disabled-image" alt="PayPal Disabled"></div>
              <p>PayPal is disabled if you are buying a membership in addition to your promotions.</p>
            </div>
          }
        </div>
      </div>
      <app-new-error-modal modalId="payment-error-modal" [options]="errorOptions"
      [textList]="errorExtra"></app-new-error-modal>
